// React Required
import React, { Component } from "react";
import ReactDOM from "react-dom";

// Create Import File
import "./index.scss";

// Dark Home Layout
import DarkPortfolioLanding from "./dark/PortfolioLanding";

import { BrowserRouter, Switch, Route } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";

class Root extends Component {
   state = {
     loading: true
   };
  
   componentDidMount() {
     this.fakeRequest().then(() => {
       const el = document.querySelector("#load");
       if (el) {
         el.style.display="none"  // removing the spinner element
         this.setState({ loading: false }); // showing the app
       }
     });
   }

   fakeRequest = () => {
     return new Promise(resolve => setTimeout(() => resolve(), 2500));
  };



  render() {
    
    


    return (
      <BrowserRouter basename={"/"}>
        <Switch>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/`}
            component={DarkPortfolioLanding}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
